import { render, staticRenderFns } from "./coLevel.vue?vue&type=template&id=42399e2c&scoped=true"
import script from "./coLevel.vue?vue&type=script&lang=js"
export * from "./coLevel.vue?vue&type=script&lang=js"
import style0 from "./coLevel.vue?vue&type=style&index=0&id=42399e2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42399e2c",
  null
  
)

export default component.exports